export enum PreferenceDistanceEnum {
    EMPTY = '',
    SHORT = 'short',
    MEDIUM = 'medium',
    LONG = 'long',
    VERY_LONG = 'very-long',
    ULTRA = 'ultra',
}
